import { render, staticRenderFns } from "./AsignarMasivo.vue?vue&type=template&id=53357cea"
import script from "./AsignarMasivo.vue?vue&type=script&lang=js"
export * from "./AsignarMasivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports